import { CheckCircle } from "@phosphor-icons/react";

import { formatPrice } from "features/subscriptions/utils";

import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";
import { Tag } from "common/components/ui/Tag";

import { BILLING_STATUSES } from "../../constants";
import { formatBillingDate } from "../../utils";
import DownloadInvoice from "./DownloadInvoice";

import type { Invoice } from "../../types";

export default function DesktopTable({ invoices }: { invoices: Invoice[] }) {
  return (
    <Table>
      <thead>
        <tr>
          <TableHead>Date</TableHead>
          <TableHead>Description</TableHead>
          <TableHead>Number of seats</TableHead>
          <TableHead>Total amount</TableHead>
          <TableHead>Payment status</TableHead>
          <TableHead />
        </tr>
      </thead>

      <tbody>
        {invoices.map(({ id, date, total, line_items, status }) => {
          const seatsLineItem = line_items.find(
            ({ entity_type }) => entity_type === "addon_item_price",
          );
          // line items can be an empty array
          let plan = "-";
          if (line_items.length) {
            const mainLineItem = line_items.find(
              ({ entity_type }) => entity_type === "plan_item_price",
            );
            const adhocLineItem = line_items.find(
              ({ entity_type }) => entity_type === "adhoc",
            );
            plan =
              mainLineItem?.description ||
              seatsLineItem?.description ||
              adhocLineItem?.description;
          }
          return (
            <TableRow key={id}>
              <TableCell className="text-sm-bold">
                {formatBillingDate(date * 1000)}
              </TableCell>

              <TableCell>{plan}</TableCell>

              <TableCell>
                {seatsLineItem ? seatsLineItem.quantity : "-"}
              </TableCell>

              <TableCell className="text-button-xs">
                {formatPrice(total)}
              </TableCell>

              <TableCell>
                <Tag
                  variant="tertiary"
                  leftIcon={
                    status === "paid" && (
                      <CheckCircle className="text-green-500" weight="fill" />
                    )
                  }
                  size="md"
                >
                  {BILLING_STATUSES[status].label}
                </Tag>
              </TableCell>

              <TableCell>
                <DownloadInvoice invoiceId={id} />
              </TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
}
